// Translations for Board Report
export const translations = {
  es: {
    // Header
    title: 'Reporte Ejecutivo',
    subtitle: 'Análisis Financiero Integral',
    generatedOn: 'Generado el',
    period: 'Período',
    currency: 'Moneda',
    
    // Tabs
    tabSummary: 'Resumen',
    tabMargins: 'Márgenes',
    tabReturns: 'Retornos',
    tabEfficiency: 'Eficiencia',
    tabLiquidity: 'Liquidez',
    tabSolvency: 'Solvencia',
    tabTrends: 'Tendencias',
    
    // Executive Summary
    executiveSummary: 'Resumen Ejecutivo',
    keyMetrics: 'Métricas Clave',
    revenue: 'Ingresos',
    grossProfit: 'Utilidad Bruta',
    ebitda: 'EBITDA',
    netProfit: 'Utilidad Neta',
    totalAssets: 'Activo Total',
    totalLiabilities: 'Pasivo Total',
    equity: 'Capital Contable',
    
    // Margins
    marginsAnalysis: 'Análisis de Márgenes',
    grossMargin: 'Margen Bruto',
    ebitdaMargin: 'Margen EBITDA',
    operatingMargin: 'Margen Operativo',
    netMargin: 'Margen Neto',
    nopatMargin: 'Margen NOPAT',
    marginWaterfall: 'Cascada de Márgenes',
    
    // Returns
    returnsOnInvestment: 'Retorno sobre Inversión',
    roic: 'ROIC',
    roe: 'ROE',
    roa: 'ROA',
    roce: 'ROCE',
    ronic: 'RONIC',
    gmroi: 'GMROI',
    
    // Efficiency
    operationalEfficiency: 'Eficiencia Operativa',
    assetTurnover: 'Rotación de Activos',
    receivablesTurnover: 'Rotación de CxC',
    inventoryTurnover: 'Rotación de Inventario',
    payablesTurnover: 'Rotación de CxP',
    dso: 'Días de Cobro (DSO)',
    dpo: 'Días de Pago (DPO)',
    dio: 'Días de Inventario (DIO)',
    cashConversionCycle: 'Ciclo de Conversión',
    
    // Liquidity
    liquidityAnalysis: 'Análisis de Liquidez',
    currentRatio: 'Razón Circulante',
    quickRatio: 'Prueba Ácida',
    cashRatio: 'Razón de Efectivo',
    workingCapital: 'Capital de Trabajo',
    cashRunway: 'Cash Runway',
    cashEfficiency: 'Eficiencia de Efectivo',
    
    // Solvency
    solvencyAnalysis: 'Análisis de Solvencia',
    debtToEquity: 'Deuda / Capital',
    debtToAssets: 'Deuda / Activos',
    debtToEbitda: 'Deuda / EBITDA',
    netDebtToEbitda: 'Deuda Neta / EBITDA',
    interestCoverage: 'Cobertura de Intereses',
    financialLeverage: 'Apalancamiento',
    equityRatio: 'Razón de Capital',
    
    // Trends
    monthlyTrends: 'Tendencias Mensuales',
    revenueAndProfit: 'Ingresos y Utilidades',
    marginsTrend: 'Evolución de Márgenes',
    returnsTrend: 'Evolución de Retornos',
    
    // Sankey
    sankeyTitle: 'Flujo del Estado de Resultados',
    sankeyDesc: 'Visualización del flujo desde Ingresos hasta Utilidad Neta',
    costOfSales: 'Costo de Ventas',
    operatingExpenses: 'Gastos Operativos',
    operatingProfit: 'Utilidad Operativa',
    otherExpenses: 'Otros Gastos',
    taxes: 'Impuestos',
    
    // Capital Structure
    capitalStructure: 'Estructura de Capital',
    currentAssets: 'Activo Circulante',
    fixedAssets: 'Activo Fijo',
    currentLiabilities: 'Pasivo Circulante',
    longTermLiabilities: 'Pasivo Largo Plazo',
    
    // Comparison
    comparison: 'Comparativo',
    vsPreviousPeriod: 'vs Período Anterior',
    vsLastYear: 'vs Año Anterior',
    change: 'Cambio',
    
    // Export
    exportPdf: 'Exportar PDF',
    exportExcel: 'Exportar Excel',
    exporting: 'Exportando...',
    
    // Status
    positive: 'Positivo',
    negative: 'Negativo',
    neutral: 'Neutral',
    trend: 'Tendencia',
    
    // Units
    times: 'veces',
    days: 'días',
    months: 'meses',
    percentage: '%',
    
    // Period Selector
    periodType: 'Tipo de Período',
    selectPeriod: 'Seleccionar Período',
    monthly: 'Mensual',
    quarterly: 'Trimestral',
    annual: 'Anual',
    generic: 'Genérico',
    lastMonth: 'Último Mes',
    lastQuarter: 'Último Trimestre',
    lastYear: 'Último Año',
    periodsIncluded: 'Períodos incluidos',
    
    // PDF Export
    pdfGenerating: 'Generando PDF completo...',
    pdfSuccess: 'PDF generado exitosamente',
    pdfError: 'Error al generar PDF',
    page: 'Página',
    of: 'de',
    confidential: 'CONFIDENCIAL',
    preparedFor: 'Preparado para',
    financialSummary: 'Resumen Financiero',
    incomeStatement: 'Estado de Resultados',
    balanceSheet: 'Balance General',
    metricsDetail: 'Detalle de Métricas',
    good: 'Bueno',
    warning: 'Atención',
    critical: 'Crítico',
    
    // AI Analysis
    aiAnalysis: 'Análisis Inteligente',
    aiAnalysisDesc: 'Análisis financiero generado por inteligencia artificial',
    loadingAnalysis: 'Generando análisis...',
    executiveSummaryAI: 'Resumen Ejecutivo',
    profitabilityAnalysis: 'Análisis de Rentabilidad',
    returnsAnalysis: 'Análisis de Retornos',
    liquidityAnalysisAI: 'Análisis de Liquidez',
    solvencyAnalysisAI: 'Análisis de Solvencia',
    strategicRecommendations: 'Recomendaciones Estratégicas',
    generatedByAI: 'Generado por IA',
    refreshAnalysis: 'Actualizar Análisis',
  },
  
  en: {
    // Header
    title: 'Executive Report',
    subtitle: 'Comprehensive Financial Analysis',
    generatedOn: 'Generated on',
    period: 'Period',
    currency: 'Currency',
    
    // Tabs
    tabSummary: 'Summary',
    tabMargins: 'Margins',
    tabReturns: 'Returns',
    tabEfficiency: 'Efficiency',
    tabLiquidity: 'Liquidity',
    tabSolvency: 'Solvency',
    tabTrends: 'Trends',
    
    // Executive Summary
    executiveSummary: 'Executive Summary',
    keyMetrics: 'Key Metrics',
    revenue: 'Revenue',
    grossProfit: 'Gross Profit',
    ebitda: 'EBITDA',
    netProfit: 'Net Profit',
    totalAssets: 'Total Assets',
    totalLiabilities: 'Total Liabilities',
    equity: 'Shareholders\' Equity',
    
    // Margins
    marginsAnalysis: 'Margins Analysis',
    grossMargin: 'Gross Margin',
    ebitdaMargin: 'EBITDA Margin',
    operatingMargin: 'Operating Margin',
    netMargin: 'Net Margin',
    nopatMargin: 'NOPAT Margin',
    marginWaterfall: 'Margin Waterfall',
    
    // Returns
    returnsOnInvestment: 'Return on Investment',
    roic: 'ROIC',
    roe: 'ROE',
    roa: 'ROA',
    roce: 'ROCE',
    ronic: 'RONIC',
    gmroi: 'GMROI',
    
    // Efficiency
    operationalEfficiency: 'Operational Efficiency',
    assetTurnover: 'Asset Turnover',
    receivablesTurnover: 'Receivables Turnover',
    inventoryTurnover: 'Inventory Turnover',
    payablesTurnover: 'Payables Turnover',
    dso: 'Days Sales Outstanding',
    dpo: 'Days Payable Outstanding',
    dio: 'Days Inventory Outstanding',
    cashConversionCycle: 'Cash Conversion Cycle',
    
    // Liquidity
    liquidityAnalysis: 'Liquidity Analysis',
    currentRatio: 'Current Ratio',
    quickRatio: 'Quick Ratio',
    cashRatio: 'Cash Ratio',
    workingCapital: 'Working Capital',
    cashRunway: 'Cash Runway',
    cashEfficiency: 'Cash Efficiency',
    
    // Solvency
    solvencyAnalysis: 'Solvency Analysis',
    debtToEquity: 'Debt to Equity',
    debtToAssets: 'Debt to Assets',
    debtToEbitda: 'Debt to EBITDA',
    netDebtToEbitda: 'Net Debt to EBITDA',
    interestCoverage: 'Interest Coverage',
    financialLeverage: 'Financial Leverage',
    equityRatio: 'Equity Ratio',
    
    // Trends
    monthlyTrends: 'Monthly Trends',
    revenueAndProfit: 'Revenue & Profit',
    marginsTrend: 'Margins Evolution',
    returnsTrend: 'Returns Evolution',
    
    // Sankey
    sankeyTitle: 'Income Statement Flow',
    sankeyDesc: 'Flow visualization from Revenue to Net Profit',
    costOfSales: 'Cost of Sales',
    operatingExpenses: 'Operating Expenses',
    operatingProfit: 'Operating Profit',
    otherExpenses: 'Other Expenses',
    taxes: 'Taxes',
    
    // Capital Structure
    capitalStructure: 'Capital Structure',
    currentAssets: 'Current Assets',
    fixedAssets: 'Fixed Assets',
    currentLiabilities: 'Current Liabilities',
    longTermLiabilities: 'Long-term Liabilities',
    
    // Comparison
    comparison: 'Comparison',
    vsPreviousPeriod: 'vs Previous Period',
    vsLastYear: 'vs Last Year',
    change: 'Change',
    
    // Export
    exportPdf: 'Export PDF',
    exportExcel: 'Export Excel',
    exporting: 'Exporting...',
    
    // Status
    positive: 'Positive',
    negative: 'Negative',
    neutral: 'Neutral',
    trend: 'Trend',
    
    // Units
    times: 'times',
    days: 'days',
    months: 'months',
    percentage: '%',
    
    // Period Selector
    periodType: 'Period Type',
    selectPeriod: 'Select Period',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    annual: 'Annual',
    generic: 'Generic',
    lastMonth: 'Last Month',
    lastQuarter: 'Last Quarter',
    lastYear: 'Last Year',
    periodsIncluded: 'Periods included',
    
    // PDF Export
    pdfGenerating: 'Generating complete PDF...',
    pdfSuccess: 'PDF generated successfully',
    pdfError: 'Error generating PDF',
    page: 'Page',
    of: 'of',
    confidential: 'CONFIDENTIAL',
    preparedFor: 'Prepared for',
    financialSummary: 'Financial Summary',
    incomeStatement: 'Income Statement',
    balanceSheet: 'Balance Sheet',
    metricsDetail: 'Metrics Detail',
    good: 'Good',
    warning: 'Warning',
    critical: 'Critical',
    
    // AI Analysis
    aiAnalysis: 'AI Analysis',
    aiAnalysisDesc: 'Financial analysis powered by artificial intelligence',
    loadingAnalysis: 'Generating analysis...',
    executiveSummaryAI: 'Executive Summary',
    profitabilityAnalysis: 'Profitability Analysis',
    returnsAnalysis: 'Returns Analysis',
    liquidityAnalysisAI: 'Liquidity Analysis',
    solvencyAnalysisAI: 'Solvency Analysis',
    strategicRecommendations: 'Strategic Recommendations',
    generatedByAI: 'Generated by AI',
    refreshAnalysis: 'Refresh Analysis',
  },
  
  pt: {
    // Header
    title: 'Relatório Executivo',
    subtitle: 'Análise Financeira Integral',
    generatedOn: 'Gerado em',
    period: 'Período',
    currency: 'Moeda',
    
    // Tabs
    tabSummary: 'Resumo',
    tabMargins: 'Margens',
    tabReturns: 'Retornos',
    tabEfficiency: 'Eficiência',
    tabLiquidity: 'Liquidez',
    tabSolvency: 'Solvência',
    tabTrends: 'Tendências',
    
    // Executive Summary
    executiveSummary: 'Resumo Executivo',
    keyMetrics: 'Métricas Chave',
    revenue: 'Receita',
    grossProfit: 'Lucro Bruto',
    ebitda: 'EBITDA',
    netProfit: 'Lucro Líquido',
    totalAssets: 'Ativo Total',
    totalLiabilities: 'Passivo Total',
    equity: 'Patrimônio Líquido',
    
    // Margins
    marginsAnalysis: 'Análise de Margens',
    grossMargin: 'Margem Bruta',
    ebitdaMargin: 'Margem EBITDA',
    operatingMargin: 'Margem Operacional',
    netMargin: 'Margem Líquida',
    nopatMargin: 'Margem NOPAT',
    marginWaterfall: 'Cascata de Margens',
    
    // Returns
    returnsOnInvestment: 'Retorno sobre Investimento',
    roic: 'ROIC',
    roe: 'ROE',
    roa: 'ROA',
    roce: 'ROCE',
    ronic: 'RONIC',
    gmroi: 'GMROI',
    
    // Efficiency
    operationalEfficiency: 'Eficiência Operacional',
    assetTurnover: 'Giro do Ativo',
    receivablesTurnover: 'Giro de Recebíveis',
    inventoryTurnover: 'Giro de Estoque',
    payablesTurnover: 'Giro de Fornecedores',
    dso: 'Prazo Médio de Recebimento',
    dpo: 'Prazo Médio de Pagamento',
    dio: 'Prazo Médio de Estoque',
    cashConversionCycle: 'Ciclo de Conversão',
    
    // Liquidity
    liquidityAnalysis: 'Análise de Liquidez',
    currentRatio: 'Liquidez Corrente',
    quickRatio: 'Liquidez Seca',
    cashRatio: 'Liquidez Imediata',
    workingCapital: 'Capital de Giro',
    cashRunway: 'Cash Runway',
    cashEfficiency: 'Eficiência de Caixa',
    
    // Solvency
    solvencyAnalysis: 'Análise de Solvência',
    debtToEquity: 'Dívida / Patrimônio',
    debtToAssets: 'Dívida / Ativos',
    debtToEbitda: 'Dívida / EBITDA',
    netDebtToEbitda: 'Dívida Líquida / EBITDA',
    interestCoverage: 'Cobertura de Juros',
    financialLeverage: 'Alavancagem',
    equityRatio: 'Índice de Patrimônio',
    
    // Trends
    monthlyTrends: 'Tendências Mensais',
    revenueAndProfit: 'Receita e Lucros',
    marginsTrend: 'Evolução das Margens',
    returnsTrend: 'Evolução dos Retornos',
    
    // Sankey
    sankeyTitle: 'Fluxo da DRE',
    sankeyDesc: 'Visualização do fluxo da Receita ao Lucro Líquido',
    costOfSales: 'Custo das Vendas',
    operatingExpenses: 'Despesas Operacionais',
    operatingProfit: 'Lucro Operacional',
    otherExpenses: 'Outras Despesas',
    taxes: 'Impostos',
    
    // Capital Structure
    capitalStructure: 'Estrutura de Capital',
    currentAssets: 'Ativo Circulante',
    fixedAssets: 'Ativo Fixo',
    currentLiabilities: 'Passivo Circulante',
    longTermLiabilities: 'Passivo de Longo Prazo',
    
    // Comparison
    comparison: 'Comparativo',
    vsPreviousPeriod: 'vs Período Anterior',
    vsLastYear: 'vs Ano Anterior',
    change: 'Variação',
    
    // Export
    exportPdf: 'Exportar PDF',
    exportExcel: 'Exportar Excel',
    exporting: 'Exportando...',
    
    // Status
    positive: 'Positivo',
    negative: 'Negativo',
    neutral: 'Neutro',
    trend: 'Tendência',
    
    // Units
    times: 'vezes',
    days: 'dias',
    months: 'meses',
    percentage: '%',
    
    // Period Selector
    periodType: 'Tipo de Período',
    selectPeriod: 'Selecionar Período',
    monthly: 'Mensal',
    quarterly: 'Trimestral',
    annual: 'Anual',
    generic: 'Genérico',
    lastMonth: 'Último Mês',
    lastQuarter: 'Último Trimestre',
    lastYear: 'Último Ano',
    periodsIncluded: 'Períodos incluídos',
    
    // PDF Export
    pdfGenerating: 'Gerando PDF completo...',
    pdfSuccess: 'PDF gerado com sucesso',
    pdfError: 'Erro ao gerar PDF',
    page: 'Página',
    of: 'de',
    confidential: 'CONFIDENCIAL',
    preparedFor: 'Preparado para',
    financialSummary: 'Resumo Financeiro',
    incomeStatement: 'Demonstração de Resultados',
    balanceSheet: 'Balanço Patrimonial',
    metricsDetail: 'Detalhe de Métricas',
    good: 'Bom',
    warning: 'Atenção',
    critical: 'Crítico',
    
    // AI Analysis
    aiAnalysis: 'Análise Inteligente',
    aiAnalysisDesc: 'Análise financeira gerada por inteligência artificial',
    loadingAnalysis: 'Gerando análise...',
    executiveSummaryAI: 'Resumo Executivo',
    profitabilityAnalysis: 'Análise de Rentabilidade',
    returnsAnalysis: 'Análise de Retornos',
    liquidityAnalysisAI: 'Análise de Liquidez',
    solvencyAnalysisAI: 'Análise de Solvência',
    strategicRecommendations: 'Recomendações Estratégicas',
    generatedByAI: 'Gerado por IA',
    refreshAnalysis: 'Atualizar Análise',
  }
};

export const languages = [
  { code: 'es', name: 'Español', flag: '🇲🇽' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'pt', name: 'Português', flag: '🇧🇷' },
];
